export const DISEASES = {
  ESPONDILOARTRITIS: 1,
  PSORIASIS: 2,
  GENERAL_CLINIC: 3,
  ATOPIC_DERMATITIS: 4,
  CSU: 5,
  ASTHMA: 6,
  INFLAMATORY_BOWEL_DISEASE: 7,
}

export const DISEASES_VERSION = {
  [DISEASES.PSORIASIS]: 2,
}
